export function Params () {
  function cast (val) {
    if (!isNaN(val)) return Number(val)
    if (val === "true")  return true
    if (val === "false") return false
    
    try {
      var decoded = decodeURIComponent(val)
      return JSON.parse(decoded)
    } catch(e) {}
    
    return  val
  }

  function get (key, fallback) {
    var params = parse()
    if ("undefined" === typeof key) return params
    if (window.location.search == "") return fallback
    if (key) return (params[key] || fallback)
  }

  function put (key, val) {
    var params = get()
      , qs     = "?"
    params[key] = val.toString()

    for (key in params) {
      if (!~["?", "&"].indexOf(qs[qs.length-1])) {
        qs += "&"
      }

      qs += (key + "=" + params[key])
    }

    return qs
  }

  function parse () {
    var pairs = window.location.search.replace(/^\?/, "")

    if (pairs == "") return {}

    return pairs.split("&")
      .map(function (qs_pair) { return qs_pair.split("=") })
      .reduce(function (params, pair) {
        var key = pair.shift()
          , val = cast(pair.shift())
          , target = params

        var obj_path = key.split(".")

        while (obj_path.length) {
          var k = obj_path.shift()
          if (obj_path.length == 0) {
            target[k] = val
            return params
          }

          target = target[k] = target[k] || {}
        }

        return params
      }, {})
  }

  var api = 
    { get   : get 
    , put   : put
    , parse : parse
    }
  // expose api
  return api
}
